import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M11.204 1.111H3.778a1 1 0 0 0-1 1V17.89a1 1 0 0 0 1 1h12.444a1 1 0 0 0 1-1V6.667M11.204 1.11v4.556a1 1 0 0 0 1 1h5.018M11.204 1.11l6.018 5.556M5.556 14.444h8.888m-8.888-3.333h5.555"
    }, null, -1)
  ]))]))
}
export default { render: render }